import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '@/views/Login';
import DashboardLayout from '@/views/dashboard/layout/DashboardLayout';

import HomeView from '@/views/dashboard/HomeView';
import ProductView from '@/views/dashboard/product/ProductView';
import ProductListView from '@/views/dashboard/product/ListView';
import ProductFormView from '@/views/dashboard/product/FormView';
import TransactionView from '@/views/dashboard/TransactionView';
import MarketingView from '@/views/dashboard/MarketingView';
import PluginView from '@/views/dashboard/PluginView';
import ThemeView from '@/views/dashboard/ThemeView';
import UserView from '@/views/dashboard/UserView';
import SettingView from '@/views/dashboard/SettingView';
// import store from '@/store';

const routes = [ {
    path: '/',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/',
    component: DashboardLayout,
    redirect: 'Login',
    children: [ {
      path: 'home',
      name: 'Home',
      component: HomeView,
      meta: { requireAuth: true }
    }, {
      path: 'product',
      name: 'Product',
      component: ProductView,
      children: [ {
        path: '',
        name: 'Product-List',
        component: ProductListView
      }, {
        path: 'form',
        name: 'Product-Form',
        component: ProductFormView
      } ],
      meta: { requireAuth: true }
    }, {
      path: 'transaction',
      name: 'Transaction',
      component: TransactionView,
      meta: { requireAuth: true }
    }, {
      path: 'marketing',
      name: 'Marketing',
      component: MarketingView,
      meta: { requireAuth: true }
    }, {
      path: 'plugin',
      name: 'Plugin',
      component: PluginView,
      meta: { requireAuth: true }
    }, {
      path: 'theme',
      name: 'Theme',
      component: ThemeView,
      meta: { requireAuth: true }
    }, {
      path: 'user',
      name: 'User',
      component: UserView,
      meta: { requireAuth: true }
    }, {
      path: 'setting',
      name: 'Setting',
      component: SettingView,
      meta: { requireAuth: true }
    } ]
  }
]

const router = createRouter( {
  history: createWebHistory( ),
  routes
} )

// router.beforeEach( ( to, from, next ) => {
//   if ( to.matched.some( ( record ) => record.meta.requireAuth ) ) {
//     // store.dispatch( 'check' )
//     if ( store.getters.isAuthenticated ) {
//       next( );
//       return;
//     }
//     next( '/' )
//   } else {
//     next( );
//   }
// } )

export default router